export default __webpack_public_path__ + "static/media/ProfilePic.b095abef.png";